import PropTypes from 'prop-types'

const MetaData = ({ children, content }) => (
  <If condition={content}>
    {children}
  </If>
)

export default MetaData

MetaData.propTypes = {
  children: PropTypes.elementType.isRequired,
  content: PropTypes.string.isRequired
}
